import Axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { REQUEST_DATASOURCE, REQUEST_DOWLOAD_DESCRIPTION, REQUEST_FREQUENCY, REQUEST_SOURCE, REQUEST_STATUS, REQUEST_TAB_HEADER, REQUEST_TYPE, STATUS_TYPE, REQUEST_ALERT_TYPE, REQUEST_STATUS_TYPE_MIRA } from "../../../core/dictionary/global";
import { getApiUrl } from "../../../utils/baseUrl";
import RequestAlert from "./RequestAlert";
import RequestContact from "./RequestContact";
import { RequestDownloads } from "./RequestDownloads";
import { useSelector } from "react-redux";
import RequestsDueDilligence from "./RequestsDueDilligence";
import { globalGetApiUrl } from "@utils/globalBaseUrl";

const intelAPIEndpoints = {
  notification_center: getApiUrl("notification_center/get_notifications"),
  notification_close: getApiUrl("notification_center/close_notifications"),
  profile: getApiUrl("getUserProfile"), // Deprecated - use profileComplete and profileIntel instead
  profileComplete: globalGetApiUrl("auth/getUserProfileComplete"),
  profileIntel: getApiUrl("getUserIntelDetails"),
  getDownloadShipments: getApiUrl("getDownloadShipments"),
};

const RequestCenter = (props) => {
  const { showStatus, showRequest, setShowRequest, setShowStatus, callingTrackingEvents, setShowFrequency, showFrequency, showDataSource, setShowDataSource, showDescription, setShowDescription, showAlertType, setShowAlertType, setActivetab } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const [requestType, setRequestType] = useState(REQUEST_TYPE);
  const [status, setStatus] = useState(STATUS_TYPE);
  const [loader, setLoader] = useState(false);
  const [propsDataList, setDataList] = useState([]);
  const [alertStatus, setAlertStatus] = useState(REQUEST_STATUS);
  const [alertDataSource, setAlertDataSource] = useState(REQUEST_DATASOURCE);
  const [alertFrequency, setAlertFrequency] = useState(REQUEST_FREQUENCY);
  const [description, setDescription] = useState(REQUEST_DOWLOAD_DESCRIPTION);
  const [alertType, setAlertType] = useState(REQUEST_ALERT_TYPE);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const userDetails = useSelector((state) => state.userDetails);
  const STARTERPLAN = userDetails?.creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const GLOBALPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("global"))?.navigate === "search";

  useEffect(() => {
    if (activeIndex === 0) {
      setDataList([]);
      getDataHandler(REQUEST_SOURCE[0]);
    } else if (activeIndex === 1) {
      setDataList([]);
      getDataHandler(REQUEST_SOURCE[1]);
    } else if (activeIndex === 2) {
      setDataList([]);
      getDataHandler(REQUEST_SOURCE[2]);
    }
    setAlertStatus(REQUEST_STATUS);
    setAlertDataSource(REQUEST_DATASOURCE);
    setAlertFrequency(REQUEST_FREQUENCY);
    setDescription(REQUEST_DOWLOAD_DESCRIPTION);
    setAlertType(REQUEST_ALERT_TYPE);
  }, [activeIndex]);

  useEffect(() => {
    const searchUrlParams = window.location.search;
    if (new URLSearchParams(searchUrlParams).get("activeIndex")) {
      setActiveIndex(+new URLSearchParams(searchUrlParams).get("activeIndex"));
    } else {
      if (STARTERPLAN) setActiveIndex(1);
      else setActiveIndex(0);
    }
  }, []);

  const filterContacthandler = (data) => {
    let reqTypeClone = JSON.parse(JSON.stringify(REQUEST_TYPE));
    reqTypeClone.forEach((item, index) => {
      let req = data.data.some((val) => val.requestType.toLowerCase().includes(item.payload.toLowerCase()));
      if (!req) {
        reqTypeClone.splice(index, 1);
      }
    });

    let statusClone = JSON.parse(JSON.stringify(STATUS_TYPE));
    statusClone.forEach((item, index) => {
      let req = data.data.some((val) => val.status.toLowerCase().includes(item.name.toLowerCase()));
      if (!req) {
        statusClone.splice(index, 1);
      }
    });
    setStatus(statusClone);
    setRequestType(reqTypeClone);
  };

  const filterDownloadHandler = () => {
    let dataSourceArray = [];
    let subscribedData = props.userPlan.filter((item) => item.is_subscribed);
    let dataSourceClone = JSON.parse(JSON.stringify(REQUEST_DATASOURCE));
    let statusClone = JSON.parse(JSON.stringify(REQUEST_STATUS));
    dataSourceClone.forEach((item) => {
      let req = subscribedData.some((val) => val.product_id.toLowerCase().includes(item.plan.toLowerCase()));
      if (req) {
        dataSourceArray.push(item);
      }
    });
    statusClone.splice(1, 1);
    setAlertStatus(statusClone);
    setAlertDataSource(dataSourceArray);
  };

  const filterEmailhandler = () => {
    let dataSourceArray = [];
    let subscribedData = props.userPlan.filter((item) => item.is_subscribed);
    let dataSourceClone = JSON.parse(JSON.stringify(REQUEST_DATASOURCE));
    dataSourceClone.forEach((item) => {
      let req = subscribedData.some((val) => val.product_id.toLowerCase().includes(item.plan.toLowerCase()));
      if (req) {
        dataSourceArray.push(item);
      }
    });
    setAlertDataSource(dataSourceArray);
  };

  const getDataHandler = async (source) => {
    setLoader(true);
    try {
      let {
        data: { data },
      } = await Axios.get(intelAPIEndpoints.notification_center + `?source=${source}&is_notification=false&order=desc`);
      setDataList(data.data);
      if (activeIndex === 0) {
        filterContacthandler(data);
      } else if (activeIndex === 1) {
        filterEmailhandler(data);
      } else {
        filterDownloadHandler(data);
      }
      setTimeout(() => {
        setLoader(false);
      }, 200);
    } catch (err) {
      setLoader(false);
    }
  };

  const selectDataHandler = (item, source) => {
    Axios.post(intelAPIEndpoints.notification_close, {
      request_id: [item.requestId],
    })
      .then(() => {
        setTimeout(() => {
          getDataHandler(source);
        }, 100);
      })
      .catch(() => {
        toast.error("Somtheing went wrong");
      });
  };

  const downloadDownloadedFiles = (data) => {
    if (!!data && data !== "") {
      const params = {
        file_name: data,
      };
      const apiUrl = intelAPIEndpoints.getDownloadShipments;
      Axios.get(apiUrl, { params }).then(
        (res) => {
          if (!!res && !!res.data && !!res.data.status && res.data.status.toLocaleUpperCase() === "SUCCESS".toLocaleUpperCase()) {
            window.open(res.data.data.file_url);
          } else {
            toast.error(res.data.message);
          }
        },
        () => {
          toast.error("Something went wrong. Please try again later!!!");
        }
      );
    } else {
      toast.error("Something went wrong. Please try again later !!!");
    }
  };
  return (
    <div>
      <div className="ml-4 mt-5 tw-flex tw-w-fit tw-bg-gray-100 tw-gap-1 tw-p-1 tw-rounded-lg">
        {REQUEST_TAB_HEADER.map((item, index) => {
          if (STARTERPLAN && (index === 0 || index === 3)) {
            return null;
          }
          return (
            <div key={item} onClick={() => setActiveIndex(index)} className={`${activeIndex === index ? "tw-flex tw-items-center tw-bg-white tw-py-1.5 tw-px-2 tw-rounded-[6px] tw-shadow-glossary tw-text-sm tw-font-medium tw-text-primary-purple-600" : "tw-text-sm tw-font-medium tw-text-gray-900 tw-flex tw-items-center tw-py-1.5 tw-px-2"} tw-cursor-pointer`}>
              {item}
            </div>
          );
        })}
      </div>
      <div className="horizontal-line"></div>
      {activeIndex === 0 && !STARTERPLAN ? (
        <RequestContact status={status} setStatus={setStatus} requestType={requestType} setRequestType={setRequestType} showStatus={showStatus} showRequest={showRequest} setShowRequest={setShowRequest} setShowStatus={setShowStatus} propsDataList={propsDataList} downloadDownloadedFiles={downloadDownloadedFiles} selectDataHandler={selectDataHandler} callingTrackingEvents={callingTrackingEvents} loader={loader} />
      ) : activeIndex === 1 ? (
        <RequestAlert downloadDownloadedFiles={downloadDownloadedFiles} propsDataList={propsDataList} alertStatus={alertStatus} alertDataSource={alertDataSource} alertFrequency={alertFrequency} setAlertFrequency={setAlertFrequency} setAlertDataSource={setAlertDataSource} setAlertStatus={setAlertStatus} selectDataHandler={selectDataHandler} alertType={alertType} setAlertType={setAlertType} callingTrackingEvents={callingTrackingEvents} setShowFrequency={setShowFrequency} showFrequency={showFrequency} showAlertType={showAlertType} setShowAlertType={setShowAlertType} showDataSource={showDataSource} setShowDataSource={setShowDataSource} setShowStatus={setShowStatus} showStatus={showStatus} loader={loader} setActivetab={setActivetab} setLoader={setLoader} GLOBALPLAN={GLOBALPLAN} />
      ) : activeIndex === 2 ? (
        <RequestDownloads downloadDownloadedFiles={downloadDownloadedFiles} propsDataList={propsDataList} alertStatus={alertStatus} alertDataSource={alertDataSource} setAlertDataSource={setAlertDataSource} setShowDescription={setShowDescription} setDescription={setDescription} showDescription={showDescription} description={description} setAlertStatus={setAlertStatus} selectDataHandler={selectDataHandler} callingTrackingEvents={callingTrackingEvents} showDataSource={showDataSource} setShowDataSource={setShowDataSource} setShowStatus={setShowStatus} showStatus={showStatus} loader={loader} userPlan={props.userPlan} setLoader={setLoader} GLOBALPLAN={GLOBALPLAN} />
      ) : (
        <RequestsDueDilligence index={activeIndex} alertDataSource={REQUEST_STATUS_TYPE_MIRA} />
      )}
    </div>
  );
};

export default RequestCenter;
